import { FormWrapperInputComponent } from 'containers/backend/common/component/Index'
import UploadImage from 'containers/backend/common/component/UploadImage'
import Wrapper from 'containers/backend/common/component/Wrapper'
import { cloneDeep } from 'lodash'
import React, { Fragment } from 'react'

const Media = (props) => {
    //! State
    const {tour, validation, uploadingField, onUploadImage, onRemoveImage, getThumbSources, onChangeOrderSlide, imageUrlSlug, t} = props;
    //! Function
    const onChangeImagesOrder = (e) => {
        const slideImgs = cloneDeep(tour.slideShowImages || []);
        const newSlideImgs = slideImgs.map(x=>{
            return {
                ...x,
                order: e.findIndex(y=>y.endsWith(x.url))
            };
        }).sort((a, b) => a.order - b.order);
        onChangeOrderSlide({name: 'slideShowImages', value: newSlideImgs});
    }
    //! Effect

    //! Render
  return (
    <Fragment>
        
            <FormWrapperInputComponent
                typeInput={true}
                isRequired={'right'}
                isValidation={true}
                dataValidation={tour.slideShowImages}
                validation={validation.slideShowImages}
                messageBelowInput={true}
                classLabel="col-md-2"
                classInputForm="col-md-10"
                labelTitle={t(`item.tour.slideShowImages`)}
                className="mb-0"
            >
                <UploadImage
                    multiple={true}
                    isPreview3x3={true}
                    loading={uploadingField === 'slideShowImages'}
                    thumbnailSize={120}
                    buttonSize={120}
                    uploadText={t('item.tour.uploadFileVideo')}
                    loadingText={t('item.tour.uploading')}
                    allowChangeOrder={true}
                    onChange={files => onUploadImage(files, 'slideShowImages', imageUrlSlug)}
                    onChangeOrder={onChangeImagesOrder}
                    onRemoveThumbnail={(url) => onRemoveImage(url, 'slideShowImages')}
                    thumbnails={getThumbSources(tour.slideShowImages)}/>
            </FormWrapperInputComponent>
    </Fragment>
  )
}

export default Media